import React from "react";
import { Card, Row, Col, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { BsArchiveFill } from "react-icons/bs";

const { Title } = Typography;

const ARCHIVE_SECTIONS = [
  { path: "/archive/orders", label: "Заказы" },
  { path: "/archive/transactions", label: "Транзакции" },
  { path: "/archive/salary-reports", label: "Отчёты (Зарплата)" },
  { path: "/archive/reports", label: "Отчёты (Производство)" },
  { path: "/archive/cash-transfer-clients", label: "Клиенты (Обнал)" },
  { path: "/archive/clients", label: "Клиенты" },
  { path: "/archive/cash-transfers", label: "Конвертации" },
  { path: "/archive/task-order", label: "Задача заказ" },
  { path: "/archive/inventory", label: "Инвентарь" },
  { path: "/archive/inventory-logs", label: "Журнал инвентарь" },
  { path: "/archive/workers", label: "Сотрудники" },
  { path: "/archive/users", label: "Пользователи" },
];

export default function ArchivePage() {
  const navigate = useNavigate();

  return (
    <div>
      <Title level={2} style={{ marginBottom: 24 }}>
        <BsArchiveFill style={{ marginRight: 8, verticalAlign: "middle" }} />
        Архивы
      </Title>
      <Row gutter={[16, 16]}>
        {ARCHIVE_SECTIONS.map(({ path, label }) => (
          <Col xs={24} sm={12} md={8} lg={6} key={path}>
            <Card
              hoverable
              onClick={() => navigate(path)}
              style={{ cursor: "pointer" }}
            >
              {label}
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
